import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PatentsTable = () => {
  const [patents, setPatents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalElements, setTotalElements] = useState(0);  // Total patents count
  const [totalPages, setTotalPages] = useState(0);        // Total pages
  const [currentPage, setCurrentPage] = useState(0);       // Current page number

  useEffect(() => {
    const fetchPatents = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/patents?page=${currentPage}&size=20`);
        const patentsData = response.data._embedded.patents || [];
        setPatents(patentsData);
        setTotalElements(response.data.page.totalElements);
        setTotalPages(response.data.page.totalPages);
      } catch (err) {
        console.error('Error fetching patents:', err);
        setError('Failed to fetch patents.');
      } finally {
        setLoading(false);
      }
    };

    fetchPatents();
  }, [currentPage]);  // Fetch patents whenever currentPage changes

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1); // Move to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1); // Move to previous page
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">Patents</h2>
      <p className="text-center">Total Patents: {totalElements}</p> {/* Display total count */}
      <table className="table table-bordered stikcy-top">
        <thead>
          <tr>
            <th>ID</th>
            <th>Department</th>
            <th>Title</th>
            <th>Application Number</th>
            <th>Year</th>
            <th>Filing Date</th>
            <th>Status</th>
            <th>Published Date</th>
            <th>FER Submitted Date</th>
            <th>Hearing Date</th>
            <th>Granted Date</th>
            <th>Patent Number</th>
            <th>Technology Readiness Level</th>
          </tr>
        </thead>
        <tbody>
          {patents.length === 0 ? (
            <tr><td colSpan="13" className="text-center">No patents available</td></tr>
          ) : (
            patents.map((patent) => (
              <tr key={patent.id}>
                <td>{patent.id}</td>
                <td>{patent.department}</td>
                <td>{patent.title}</td>
                <td>{patent.applicationNumber}</td>
                <td>{patent.year}</td>
                <td>{patent.filingDate}</td>
                <td>{patent.status}</td>
                <td>{patent.publishedDate}</td>
                <td>{patent.ferSubmittedDate}</td>
                <td>{patent.hearingDate}</td>
                <td>{patent.grantedDate || 'N/A'}</td>
                <td>{patent.patentNumber || 'N/A'}</td>
                <td>{patent.technologyReadinessLevel}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="d-flex justify-content-center">
        <button 
          className="btn btn-primary mx-2" 
          onClick={handlePreviousPage} 
          disabled={currentPage === 0}>
          Previous
        </button>
        <span className="my-auto">Page {currentPage + 1} of {totalPages}</span>
        <button 
          className="btn btn-primary mx-2" 
          onClick={handleNextPage} 
          disabled={currentPage === totalPages - 1}>
          Next
        </button>
      </div>
    </div>
  );
};

export default PatentsTable;
